export interface Message {
  reqId: string;
  messageId: string | null;
  sessionId: string;
  senderType: string;
  content: string;
  hashS3Key: string | null;
  fileName: string | null;
  isoCreatedAt: string;
  status: ReadStatus;
  senderName: string | null;
}

export interface MessageSendingDTO {
  reqId: string;
  content: string;
  hashS3Key: string | null;
  fileName: string | null;
}

export interface AcknowledgeDTO {
  reqId: string;
  messageId: string;
  isoCreatedAt: string;
}

export interface UserStatusDTO {
  status: UserStatus;
}

export interface MessageReadRequestDTO {
  messageIds: string[];
}

export interface ReadStatusDTO {
  messageId: string;
  status: ReadStatus;
}

export interface JobRecommendTaskDTO {
  status: AiTaskStatus;
  jobRecommendTaskId: string;
  jobTitle: string;
  location: string;
  chatSessionId: string;
}

export interface ResumeSummarizeTaskDTO {
  status: AiTaskStatus;
  resumeSummarizeTaskId: string;
}

export enum AiTaskStatus {
  DONE = "DONE",
  OOPS = "OOPS",
  RUNNING = "RUNNING",
  PENDING = "PENDING",
}

export enum ResumeSummarizeTaskStatus {
  NO_RESUME = "NO_RESUME",
  PROCESSING = "PROCESSING",
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  AWAY = "AWAY",
}

export interface SessionUserStatus {
  sessionId: string;
  userStatus: UserStatus;
}

export enum ReadStatus {
  READ = "READ",
  UNREAD = "UNREAD",
}

export enum SenderType {
  ADMIN = "ADMIN",
  USER = "USER",
}
